window.inn = window.inn || {};
window.inn.texts = window.inn.texts || {};
import validation from './validation';

export const getText = key => window.inn.texts[key] || '';

const loginTexts = {
    'existing-user.label.pin': window.inn.texts['existing-user.label.pin'] || '',
    'existing-user.label.password': window.inn.texts['existing-user.label.password'] || '',
    'existing-user.button.getPin': window.inn.texts['existing-user.button.getPin'] || '',
    'existing-user.button.submit': window.inn.texts['existing-user.button.submit'] || '',
    'existing-user.info': window.inn.texts['existing-user.info'] || '',
    'existing-user.help-text': window.inn.texts['existing-user.help-text'] || '',
    'existing-user.phone-input.placeholder':
        window.inn.texts['existing-user.phone-input.placeholder'] || '',
    'existing-user.reset-password': window.inn.texts['existing-user.reset-password'] || '',
    'register.phone.placeholder': window.inn.texts['register.phone.placeholder'] || '',
    'register.firstname.placeholder': window.inn.texts['register.firstname.placeholder'] || '',
    'register.lastname.placeholder': window.inn.texts['register.lastname.placeholder'] || '',
    'register.streetaddress.placeholder':
        window.inn.texts['register.streetaddress.placeholder'] || '',
    'register.zipcode.placeholder': window.inn.texts['register.zipcode.placeholder'] || '',
    'register.city.placeholder': window.inn.texts['register.city.placeholder'] || '',
    'register.email.placeholder': window.inn.texts['register.email.placeholder'] || '',
    'register.pin.placeholder': window.inn.texts['register.pin.placeholder'] || '',
    'register.submit': window.inn.texts['register.submit'] || '',
    'register.change-data-button': window.inn.texts['register.change-data-button'] || '',
    'register.no-registration-link-text':
        window.inn.texts['register.no-registration-link-text'] || '',
    'register.conditions': window.inn.texts['register.conditions'] || '',
    'login.wrong-pin': window.inn.texts['login.wrong-pin'] || '',
    'login.wrong-password': window.inn.texts['login.wrong-password'] || '',
    'existing-user.pin-troubleshooter':
        window.inn.texts['existing-user.pin-troubleshooter'] || 'Ikke PIN?',
    'register-user.pin-troubleshooter':
        window.inn.texts['register-user.pin-troubleshooter'] || 'Ikke PIN?',
    'register-user.pin-send-again':
        window.inn.texts['register-user.pin-send-again'] || 'Send engangskode på nytt',
    'existing-user.pin-send-again':
        window.inn.texts['existing-user.pin-send-again'] || 'Send engangskode på nytt',
    'register.pin-send-failure-report':
        window.inn.texts['register.pin-send-failure-report'] ||
        'Sending av pin mislyktes. Vennligst kontakt teknisk support:<div><b>Telefon:</b> 22551020</div> <div><b>E-post:</b> <a href="mailto:kontakt@opplysningen.no">kontakt@opplysningen.no</a></div>',
    'register.continue': window.inn.texts['register.continue'] || 'Fortsett',
    'consent-allow-to-login.info': window.inn.texts['consent-allow-to-login.info'] || 'Allow to login to Opplysningen services',
    'register.confirm': window.inn.texts['register.confirm'] || 'Vi oppretter en ny bruker med denne informasjonen',

    'login-send-pin': window.inn.texts['login-send-pin'] || 'Send PIN',
    'login-user-exists' : window.inn.texts['login-user-exists'] || 'This phone number has been registered',
    'login-pwd-verification' : window.inn.texts['login-pwd-verification'] || 'Use Password to login',
    'login-pin-verification' : window.inn.texts['login-pin-verification'] || 'Use PIN to verify'
};

export default Object.assign({}, loginTexts, validation);
